import React from 'react';

const Location = () => {
	return (
		<svg
			id="i-location"
			viewBox="0 0 36 36"
			width="48"
			height="48"
			fill="none"
			stroke="var(--text-color)"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2.3"
			aria-label="location"
			style={{ transition: 'all ease-out 1s' }}
		>
			<circle cx="16" cy="11" r="4" />
			<path d="M24 15 C21 22 16 30 16 30 16 30 11 22 8 15 5 8 10 2 16 2 22 2 27 8 24 15 Z" />
		</svg>
	);
};

export default Location;



// WEBPACK FOOTER //
// ./src/components/icons/Location.js